let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("9zLwF"), load("hNP3Q")]).then(() => parcelRequire('5lvpt'));